import { gql } from 'graphql-tag'
import { fragmentModuleNavigationLink } from '#layers/core/data-layer/modules/fragments'
import { fragmentGlobalDataTheme } from '#layers/core/data-layer/global-data/fragments'

export default gql`
  ${fragmentGlobalDataTheme}
  ${fragmentModuleNavigationLink}
  fragment BlockContentCenteredTextOnlyFragment on BlockContentCenteredTextOnly {
    sys {
      id
    }
    title
    blockContentCenteredTextOnlyDescription: description {
      json
    }
    link {
      ...ModuleNavigationLinkFragment
    }
    sectionTheme {
      ...GlobalDataThemeFragment
    }
  }
`
